import { Route, Routes } from "react-router";

import { DiagnosticPage } from "@/features/diagnostic";
import { NotFoundPage } from "@/features/not-found";

export function App() {
  return (
    <Routes>
      <Route path="/" element={<DiagnosticPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
